export const translations = {
  novaRegional: {
    pt: "Criar Regional",
    en: "Create Regional",
    de: "Region erstellen",
    es: "Crear Regional",
  },
  configuracoes: {
    pt: "Configurações",
    en: "Settings",
    de: "Einstellungen",
    es: "Configuración",
  },
  regional: {
    pt: "Regional",
    en: "Regional",
    de: "Regional",
    es: "Regional",
  },
};
